import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
  dialogPaper: {
    width: 570,
    height: 580
  }
}));
